import { StyledButton, darkColors } from '@tryhackme/thm-ui-components';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { ThemeProvider, useTheme } from 'styled-components';
import { useTrackEventMutation } from 'src/common/slices';
import { Countdown } from '../../components/countdown';
import { useActiveCampaign } from '../../hooks/use-active-campaign';
import { useCampaignCta, useGoal } from '../summer-deal.hooks';
import { UserGoal } from 'src/common/enums';
import { ButtonWrapper, StyledAnimatableBox, StyledBar, StyledText, StyledTitle, StyledWrapRow } from './summer-deal-top-bar.styles';
import type { SummerDealTopBarProps } from './summer-deal-top-bar.types';
export const SummerDealTopBar = ({
  hideCTA
}: SummerDealTopBarProps) => {
  const theme = useTheme();
  const [trackEvent] = useTrackEventMutation();
  const [goal, goalTitle] = useGoal();
  const {
    pathname
  } = useLocation();
  const {
    campaign
  } = useActiveCampaign();
  const [ctaText, urlToNavigate] = useCampaignCta(campaign);
  const onCtaClick = () => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises: Fire-and-forget analytics tracking
    trackEvent({
      event: 'click-subscribe-now',
      properties: {
        'clicked-on': 'top-banner',
        campaign: campaign?.name,
        path: pathname
      }
    });
  };
  if (!campaign) return null;
  const campaignText = <StyledText>
      SUMMER DEAL: <span>{campaign.amount}% OFF</span> ANNUAL SUBSCRIPTIONS
    </StyledText>;
  const goalText = <StyledText>{goalTitle}</StyledText>;

  // goal text too big, so we swap
  const showGoalFirst = goal === UserGoal.EVALUTE_THM;
  return <ThemeProvider theme={{
    ...theme,
    colors: darkColors
  }} data-sentry-element="ThemeProvider" data-sentry-component="SummerDealTopBar" data-sentry-source-file="summer-deal-top-bar.tsx">
      <StyledBar data-testid="campaign-bar" data-sentry-element="StyledBar" data-sentry-source-file="summer-deal-top-bar.tsx">
        <StyledWrapRow data-sentry-element="StyledWrapRow" data-sentry-source-file="summer-deal-top-bar.tsx">
          <StyledTitle data-testid="campaign-top-bar-text" data-sentry-element="StyledTitle" data-sentry-source-file="summer-deal-top-bar.tsx">
            {goalTitle ? <>
                <StyledAnimatableBox $animate $delay={showGoalFirst}>
                  {campaignText}
                </StyledAnimatableBox>
                <StyledAnimatableBox $animate $delay={!showGoalFirst}>
                  {goalText}
                </StyledAnimatableBox>
              </> : <StyledAnimatableBox>{campaignText}</StyledAnimatableBox>}
          </StyledTitle>
        </StyledWrapRow>
        <StyledWrapRow data-sentry-element="StyledWrapRow" data-sentry-source-file="summer-deal-top-bar.tsx">
          {!hideCTA && <ButtonWrapper>
              <StyledButton as={Link} to={urlToNavigate} variant="solid" color="primary" onClick={onCtaClick}>
                {ctaText}
              </StyledButton>
            </ButtonWrapper>}
          <Countdown includeDays vertical dark startTime={campaign.startTime} endTime={campaign.endTime} data-sentry-element="Countdown" data-sentry-source-file="summer-deal-top-bar.tsx" />
        </StyledWrapRow>
      </StyledBar>
    </ThemeProvider>;
};